// =============================================================================
// Origin UI — src/services/dashboardApi.ts
// API functions for the Dashboard / Home Screen endpoint.
// =============================================================================

import { api } from './apiService';
import type { DashboardResponse } from '@/types/api';

export const dashboardApi = {
  /** Fetch the complete dashboard payload for the current user. */
  getDashboard: () => api.get<DashboardResponse>('/api/dashboard'),
};
